export enum VideoHosting {
  VK = 'vk',
  RUTUBE = 'rutube',
  YOUTUBE = 'youtube',
  DZEN = 'dzen',
}
